// extracted by mini-css-extract-plugin
export default {"warranty":"product-warranty__warranty___3ByXf"};